import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Header = (props) => {
  const { branding } = props;
  return (
    <nav className="navbar navbar-expand-sm navbar-dark bg-primary mb-3 py-0">
      <div className="container">
        <a href="/" className="navbar-brand">
          {branding}
        </a>
        <div>
          <ul className="navbar-nav mr-auto">
            <li className="navbar-item">
              <Link to="/" className="nav-link">
                <i className="fas fa-home"> Home</i>
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/contact/add" className="nav-link">
                <i className="fas fa-plus"> Add</i>
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/about" className="nav-link">
                <i className="fas fa-question"> About</i>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

Header.defaultProps = {
  branding: 'My App',
};

Header.protoTypes = {
  branding: PropTypes.string.isRequired,
};

export default Header;
